package com.devi3east.bashbuddy.cart.data.api

import com.devi3east.bashbuddy.cart.results.CheckoutResult
import com.devi3east.bashbuddy.exceptions.InventoryErrorResponse
import com.devi3east.bashbuddy.purchase.requests.PurchaseInitRequest
import com.devi3east.bashbuddy.purchase.responses.PurchaseConfirmResponse
import com.devi3east.bashbuddy.purchase.responses.PurchaseInitResponse
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.headers
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.client.statement.HttpResponse
import io.ktor.http.ContentType
import io.ktor.http.HttpHeaders
import io.ktor.http.HttpStatusCode
import io.ktor.http.contentType

class CartApi(
    private val client: HttpClient,
    private val baseUrl: String
) {

    suspend fun checkout(
        token: String,
        request: PurchaseInitRequest
    ): CheckoutResult {
        return try {
            val response: HttpResponse = client.post("$baseUrl/purchases/init") {
                headers { append(HttpHeaders.Authorization, "Bearer $token") }
                contentType(ContentType.Application.Json)
                setBody(request)
            }
            when (response.status) {
                HttpStatusCode.OK -> {
                    val body = response.body<PurchaseInitResponse>()
                    CheckoutResult.Success(body)
                }
                HttpStatusCode.Conflict -> {
                    val body = response.body<InventoryErrorResponse>()
                    CheckoutResult.InventoryError(body)
                }
                else -> {
                    CheckoutResult.Failure(
                        RuntimeException("Unexpected response: ${response.status}")
                    )
                }
            }
        } catch (e: Exception) {
            CheckoutResult.Failure(e)
        }
    }

    suspend fun confirmPurchase(
        token: String,
        sessionId: String
    ): PurchaseConfirmResponse {
        return client.post("$baseUrl/purchases/confirm/$sessionId") {
            headers { append(HttpHeaders.Authorization, "Bearer $token") }
        }.body()
    }

}